var loadSource = function(dataSrc, success){
    var img = new Image(),
    $image = $(dataSrc.target),
    success = success || (function(){}),
    src;
    var article = $image.closest('article');

    checkWindowWidth(function(){
        src = dataSrc.mob  || dataSrc.desk;
    },function(){
        src = dataSrc.tab || dataSrc.desk;
    },function(){
        src = dataSrc.desk;
    });

    // console.log(dataSrc);

    if (src) {
        $(img).on('load', function(){
            // console.log(dataSrc.bg)
            if (dataSrc.bg){
               $image
               .css('background-image', 'url('+src+')')
               .removeClass('not-loaded');
            } else {
                $image.attr('src',src);
                if($image.hasClass('js-glassify')){
                    $image.attr('data-glassify',src);
                    glassify();
                }
            }
            success();
            article.addClass('!opacity-100');
        })

        $(img).on('error', function(){
            success();
            article.addClass('!opacity-100');
        })

        img.src = src;
    } else {
        success();
        article.addClass('!opacity-100');
    }
}

var loadImg = function(array, length, index, callback){
    var callback = callback || (function(){});
    loadSource(array[index], function(){
        // console.log(index + ' - src : ' + array[index].desk);
        if (array[index].target && array[index].target[0]) {
            array[index].target[0].classList.add('!opacity-100');
        }

        if (index < length - 1) {
            loadImg(array, length, index + 1, callback);
        }else{
            callback();
            array = [];
        }
    });
}

var enqueueImgs = function(callback){
    var $asyncs = $('.js-async-img'),
    callback = callback || (function(){}),
    asyncsLength = $asyncs.length;

    if (asyncsLength){
        var imgs = $asyncs.map(function(index) {
        var dataSrc = $(this).data('src');
         dataSrc.target = $(this);
        return dataSrc;
     });
        loadImg(imgs, asyncsLength, 0, callback);
    }else{
        callback();
    }
}

$(function(){
    enqueueImgs();
})
